exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*base-link-mixin*/\n.wrapper {\n  margin-bottom: 15px; }\n\n.wrapper .action-btn {\n  display: block;\n  line-height: 40px;\n  margin: 0 -15px -10px;\n  text-align: center;\n  color: #003a90;\n  border-top: 2px solid #f5f5f5; }\n  .wrapper .action-btn i {\n    font-size: 16px;\n    display: inline-block;\n    vertical-align: middle; }\n  .wrapper .action-btn span {\n    display: inline-block;\n    vertical-align: middle; }\n  .wrapper .action-btn:hover, .wrapper .action-btn:active {\n    color: #042764; }\n    .wrapper .action-btn:hover span, .wrapper .action-btn:active span {\n      text-decoration: underline; }\n\n.-default {\n  background-color: #FFFFFF;\n  padding: 15px; }\n\n.-gallery {\n  padding: 0; }\n\n@media screen and (max-width: 767px) {\n  .-gallery {\n    display: none; }\n  .-default {\n    padding: 15px 10px; }\n  .wrapper .action-btn {\n    margin: 0 -10px -10px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/show-more-content-box/show-more-content-box.component.scss
// module id = 951
// module chunks = 22